<script setup lang="ts">
import { computed } from 'vue'
import { useRoute } from 'vue-router'
import { Home, Search, Bell } from 'lucide-vue-next'

const route = useRoute()

/**
 * 从 route.matched 推 breadcrumb：
 *   /chat/:sessionId → [ 会话中心, 会话 ]
 */
const crumbs = computed(() => {
  const list: { label: string; to?: string }[] = []
  for (const r of route.matched) {
    const title = r.meta?.title as string | undefined
    if (title) list.push({ label: title, to: r.path === route.path ? undefined : r.path })
  }
  if (list.length === 0 && route.meta.title) {
    list.push({ label: route.meta.title as string })
  }
  return list
})

const isLive = computed(
  () => route.name === 'chat-detail' || route.name === 'iot-device-detail',
)
</script>

<template>
  <header
    class="flex h-[60px] shrink-0 items-center justify-between border-b border-border bg-bg-surface px-7"
  >
    <!-- 面包屑 -->
    <div class="flex items-center gap-2">
      <Home class="h-[14px] w-[14px] text-fg-muted" />
      <template v-for="(c, i) in crumbs" :key="i">
        <span class="font-mono text-sm text-fg-muted">/</span>
        <span
          :class="[
            'font-mono text-sm',
            i === crumbs.length - 1 ? 'font-semibold text-fg-primary' : 'text-fg-tertiary',
          ]"
        >
          {{ c.label }}
        </span>
      </template>
      <span
        v-if="isLive"
        class="ml-1 inline-flex items-center gap-1 rounded bg-accent-cyan-soft px-1.5 py-0.5 font-mono text-[10px] font-bold tracking-wider text-accent-cyan"
      >
        <span class="h-1.5 w-1.5 rounded-full bg-accent-cyan" />
        LIVE
      </span>
    </div>

    <!-- 右侧：搜索 + 铃铛 -->
    <div class="flex items-center gap-3">
      <div
        class="flex h-9 w-64 items-center gap-2 rounded-lg border border-border bg-bg-surface px-3"
      >
        <Search class="h-[14px] w-[14px] text-fg-muted" />
        <span class="flex-1 truncate text-sm text-fg-muted">搜索会话、Agent、Tool…</span>
        <kbd
          class="rounded border border-border bg-bg-sunken px-1.5 py-0 font-mono text-[10px] font-semibold text-fg-tertiary"
        >
          ⌘K
        </kbd>
      </div>
      <button
        class="flex h-9 w-9 items-center justify-center rounded-lg bg-bg-subtle text-fg-secondary hover:bg-bg-sunken"
        aria-label="通知"
      >
        <Bell class="h-4 w-4" />
      </button>
    </div>
  </header>
</template>
